module.exports = __webpack_public_path__ + "img/love.3a956da0.svg";